module.exports = __webpack_public_path__ + "img/b24b644.jpg";